import React, { ReactNode } from 'react';
import styled from 'styled-components';

const TableRowWrapper = styled.tr`
    &:nth-child(even) {
        background-color: #f5f5f5;
    }
`;

interface TableRowProps {
    children: ReactNode;
}

export const TableRow: React.FC<TableRowProps> = ({ children }) => {
    return <TableRowWrapper>{children}</TableRowWrapper>;
};
